import PropTypes from 'prop-types';

const CameraOnIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="m44.89 11.902-9.008 4.382v-5.092c0-3.42-2.408-6.192-5.376-6.192H5.376C2.406 5 0 7.772 0 11.192v25.616C0 40.228 2.406 43 5.376 43h25.13c2.968 0 5.376-2.772 5.376-6.192v-5.092l9.008 4.382c1.708 1.13 3.11.2 3.11-2.064V13.976c0-2.276-1.398-3.204-3.11-2.074z"
          fill={fill}
          fillRule="nonzero"
        />
      </g>
    </svg>
  </div>
);

CameraOnIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CameraOnIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CameraOnIcon;
